import { getPartyExpectedEnd, PartyExpectedEndInput } from './get-party-expected-end';

export interface PartyOvertimeInput extends PartyExpectedEndInput {
  completedAt?: number | null;
  canceled_time?: number | null;
}

/**
 * Whether a seated party has outlasted its expected end (getPartyExpectedEnd).
 *
 * Overtime only means something when the restaurant records completion
 * (bookingOptions.servingTracking) — without it a seated party is never "late to leave".
 * A party with no duration and no fallback has no plan to outlast, so it is never overtime.
 *
 * Shared by the floor-plan card (overtime chip, red stripe) and the canvas (red progress
 * bar, red outline) so the two can't disagree about the same table.
 */
export function isPartyOvertime(
  party: PartyOvertimeInput,
  servingTracking: boolean,
  fallbackDuration: number,
  now: number,
): boolean {
  if (!servingTracking || !party.seated_time || party.completedAt || party.canceled_time) {
    return false;
  }

  if (!(party.duration || fallbackDuration)) {
    return false;
  }

  return now >= getPartyExpectedEnd(party, fallbackDuration);
}
